import { useSelector } from "react-redux";
import ProductItem from "./ProductItem";

export default function ProductContainer() {
  const products = useSelector((state) => state.products);
  return (
    <>
      <div className="productContainer" id="lws-productContainer">
        {products.length > 0 ? (
          products.map((product) => {
            return <ProductItem key={product.id} product={product} />;
          })
        ) : (
          <p>No product found</p>
        )}
      </div>
    </>
  );
}
